<template>
  <b-container class="bv-example-row" style="color: rgb(37, 91, 48)">
        <p class="title" style="color: rgb(37, 91, 48)">Beteseb <span style=" color: rgba(240, 206, 13, 0.937); margin-left: 10px;">Ekub</span></p>
        <b-card >
          <b-row no-gutters style="padding: 15px; display: flex; justify-content: center; align-items: center;">
              <b-card-img :src="require('../../assets/Tsehay_logo_big.png')" alt="Image" class="rounded-0" style="width: 150px;height: 150px;"> 
              </b-card-img>
          </b-row>
          <b-row no-gutters>
          <b-col md="12" style="display: grid; justify-content: center; align-items: center;">
              <b-card-body title=""> 
                  <b-form class="text-left" @submit="onSubmit">
                      <label for="text-pwd">Old Password</label>
                      <b-input-group class="mb-3 mr-sm-2">
                          <b-form-input id="text-pwd" :type="type1" v-model="user.oldPassword" required></b-form-input>
                          <b-input-group-append>
                          <b-button variant="outline" class="unhide" @click="showOldPassword()"><b-icon class="text-center" :icon="icon1"></b-icon></b-button>
                          </b-input-group-append>
                      </b-input-group>
                      <label for="text-pwd">New Password</label>
                      <b-input-group class="mb-3 mr-sm-2">
                          <b-form-input id="text-pwd" :type="type2" v-model="user.newPassword" required></b-form-input>
                          <b-input-group-append>
                          <b-button variant="outline" class="unhide" @click="showNewPassword()"><b-icon class="text-center" :icon="icon2"></b-icon></b-button>
                          </b-input-group-append>
                      </b-input-group>
                      <label for="text-pwd">Confirm Password</label>
                      <b-input-group class="mb-3 mr-sm-2">
                          <b-form-input id="text-pwd" :type="type3" v-model="user.confirmPassword" required></b-form-input>
                          <b-input-group-append>
                          <b-button variant="outline" class="unhide" @click="showConfirmPassword()"><b-icon class="text-center" :icon="icon3"></b-icon></b-button>
                          </b-input-group-append>
                      </b-input-group>
                      <b-button type="submit" variant="primary" style="color: rgb(37, 91, 48);font-weight: 600; " :disabled="searchFlag">Change Password</b-button>
                      <!-- <b-button to="/KYC/registerUser" variant="outline-primary" class="outline-primary">Register</b-button> -->
                  </b-form>
              </b-card-body>
          </b-col>
          </b-row>
        </b-card>
    </b-container>
</template>

<script>
export default {
    data(){
        return{
            user:{
                userId: sessionStorage.getItem("ID"),
                newPassword: '',
                oldPassword: '',
                confirmPassword: ''
            },
            type1: 'password',
            type2: 'password',
            type3: 'password',
            icon1: 'eye',
            icon2: 'eye',
            icon3: 'eye',
            searchFlag: false
        }
    },
    mounted(){
        this.changePassNotification();
    },
    methods:{
        changePassNotification(){
            this.$notifications.notify({
                message: `<span>Please change your password.</span>`,
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'warning'
            })
        },
        checkPasswordComplexity(password){
        let validationRegex = [
            { regex: /.{6,}/ }, // min 8 letters,
            { regex: /[0-9]/ }, // numbers from 0 - 9
            { regex: /[a-z]/ }, // letters from a - z (lowercase)
            { regex: /[A-Z]/}, // letters from A-Z (uppercase),
            { regex: /[^A-Za-z0-9]/} // special characters
        ];

        var checkValid =  true;
        validationRegex.forEach((item, i) => {
          var isValid = item.regex.test(password);
          checkValid = isValid
          return
        }); 
        return checkValid;
      },
      onSubmit(event) {
      event.preventDefault();

      // Check if new password matches confirm password
      if (this.user.newPassword === this.user.confirmPassword) {
        // Check password complexity
        if (this.checkPasswordComplexity(this.user.newPassword)) {
          this.searchFlag = true;

          this.$store.dispatch('changePasswordAtLogin', this.user)
            .then(response => {
              const userRole = response.data.user.role;

              // Check user role and redirect accordingly
              if (['SUPER_ADMIN', 'SUPER_MANAGER', 'SUPER_FINANCE', 'SUPER_USER'].includes(userRole)) {
                this.$router.push({ name: 'DashboardSuper' });
              } else if (['ADMIN', 'MANAGER', 'FINANCE', 'USER'].includes(userRole)) {
                this.$router.push({ name: 'Dashboard' });
              } else if (['SYSTEM_ADMIN','SYSTEM_MANAGER'].includes(userRole)) {
                this.$router.push({ name: 'UserSystem' });
              }
              else{
                this.$router.push({ name: 'DashboardSuper' });
              }

            })
            .catch(error => {
              this.$notifications.notify({
                message: error.data || 'An error occurred',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
              });
            })
            .finally(() => {
              this.searchFlag = false;
            });

        } else {
          this.$notifications.notify({
            message: `<span>Password does not meet complexity requirements.</span>`,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
        }
      } else {
        this.$notifications.notify({
          message: `<span>Passwords do not match.</span>`,
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'danger'
        });
      }
    },

        showOldPassword(){
            if(this.type1 === 'password'){
                this.type1 = 'text';
                this.icon1 = 'eye-slash'
            }
            else{
                this.type1 = 'password';
                this.icon1 = 'eye';
            }
            return;
        },
        showNewPassword(){
            if(this.type2 === 'password'){
                this.type2 = 'text';
                this.icon2 = 'eye-slash'
            }
            else{
                this.type2 = 'password';
                this.icon2 = 'eye';
            }
            return;
        },
        showConfirmPassword(){
            if(this.type3 === 'password'){
                this.type3 = 'text';
                this.icon3 = 'eye-slash'
            }
            else{
                this.type3 = 'password';
                this.icon3 = 'eye';
            }
            return;
        }
    },
}
</script>

<style scoped>
.bv-example-row{
    margin-top: 6%;
}
.form-control{
    padding: 10px;
}
.btn-primary{
    background: rgba(240, 206, 13, 0.937);
    border-color: rgba(240, 206, 13, 0.937);
    width: 100%;
}
.outline-primary{
    border-color: rgba(240, 206, 13, 0.937);
    color: rgba(240, 206, 13, 0.937);
    margin-left: 10px;
    background: transparent;
}
.outline-primary:hover {
    background: rgba(240, 206, 13, 0.937);
    color: #FFF;
}
.card{
    width: 100%;
    height: 100%;
}
.card-body{
    padding-top: 0;
    padding-bottom: 0;
}
.row > *{
    padding: 0 0;
}
.row {
    --bs-gutter-x: 2rem;
}
.bv-example-row{
     display: grid;
    justify-content: center;
    align-items: center;
}
.title{
    display: flex;
    justify-content: center;
    font-size: 30px;
    font-family: monospace;
    font-weight: bold;
}
.unhide{
    border: 1px solid #ced4da;
    color: rgb(37, 91, 48); 
    height: 100%;
}
@media (max-width: 768px) {
    .unhide{
        height: 80%;
    }
}
</style>